<template>
  <change-number/>
</template>

<script>
import ChangeNumber from '../components/LogIn/ChangeNumber.vue'
export default {
  components: {ChangeNumber},

}
</script>

<style>

</style>
